module.exports = __webpack_public_path__ + "img/classInBg.384a12df.png";